<template>
  <div
    class="group/input"
    :class="{
      'flex justify-between gap-2': flex,
    }"
  >
    <t-label v-if="label" :for="uuid" :hovered="hovered" :disabled="disabled">{{
      label
    }}</t-label>
    <textarea
      :id="uuid"
      v-model="localValue"
      class="font-regular box-border block w-full rounded-md border border-solid border-transparent bg-gray-600 px-2.5 py-[7px] font-inter text-xs leading-[17px] text-gray-50 transition duration-300 placeholder:text-gray-100 focus:!border-transparent focus:bg-gray-700 focus:!text-gray-10 focus:outline focus:outline-2 focus:outline-accent-1 disabled:!cursor-not-allowed disabled:!border-transparent disabled:!bg-gray-600 disabled:!text-gray-200 group-hover/input:border-gray-400 group-hover:border-gray-400"
      :class="{
        'resize-none': noResize,
        'resize-y': !noResize,
      }"
      :placeholder="placeholder"
      :disabled="disabled"
      :rows="rows"
      :readonly="readonly"
      @mouseover="hovered = true"
      @mouseleave="hovered = false"
      @wheel.stop
    ></textarea>
  </div>
</template>
<script lang="ts" setup>
import { v4 as uuidv4 } from "uuid";
import TLabel from "../TLabel/TLabel.vue";
import { ref, computed } from "vue";

const uuid = uuidv4();
const hovered = ref(false);

const emit = defineEmits(["update:modelValue"]);

const props = defineProps({
  label: {
    type: String,
    default: "",
  },
  modelValue: {
    type: String,
    default: "",
  },
  placeholder: {
    type: String,
    default: "",
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  rows: {
    type: Number,
    default: 2,
  },
  readonly: {
    type: Boolean,
    default: false,
  },
  noResize: {
    type: Boolean,
    default: false,
  },
  flex: {
    type: Boolean,
    default: false,
  },
});

const localValue = computed({
  get() {
    return props.modelValue;
  },

  set(e: string) {
    emit("update:modelValue", e);
  },
});
</script>
<style lang="scss"></style>
